'use client'
import Image, { ImageProps } from 'next/image'
import { useState } from 'react'
import DefaultImage from '@/public/images/v2/default/basic.png'
interface ImageWithFallbackProps extends ImageProps {
  fallback?: string
}

export function ImageWithFallback({
  fallback = DefaultImage.src,
  alt,
  src,
  width,
  height,
  ...props
}: ImageWithFallbackProps) {
  const [hasImgError, setIsImgError] = useState<boolean>(false)

  return (
    <Image
      alt={alt}
      src={hasImgError ? fallback : src}
      width={width}
      height={height}
      onError={() => setIsImgError(true)}
      {...props}
    />
  )
}
